import { Component } from 'react';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Sex, TitlePrefix } from '@mews-commander/data-access';
import {
    birthDateRange,
    dateString,
    DateStringPickerField,
    email,
    EnumSelectField,
    InputField,
    maxInputTextLength,
    presence,
    TelephoneInputField,
    LanguageSelectField,
    NationalitySelectField,
} from '@mews-commander/legacy-form';
import { FieldsContainer } from '@mews-commander/ui';

export default class ProfileCreationFormFields extends Component {
    render() {
        // @ts-expect-error $TSFixMeError: Property 'onSuccess' does not exist on type 'Readonly<{}> & Readonly<{ children?: ReactNode; }>'.
        const { onSuccess, onSubmitFail, allowDateReset, isScanner, ...other } = this.props;

        return (
            <FieldsContainer {...other}>
                {!isScanner && <InputField {...emailProps} />}
                <EnumSelectField
                    enumClass={TitlePrefix}
                    enumPrefix="TitlePrefix"
                    label={<LocalizedText textKey={TextKey.Title} />}
                    name="titlePrefix"
                    showEmptyValue
                />
                <InputField {...firstNameProps} />
                <InputField {...lastNameProps} />
                {!isScanner && <LanguageSelectField {...languageProps} />}
                <NationalitySelectField {...nationalityProps} />
                <EnumSelectField
                    enumClass={Sex}
                    enumPrefix="Sex"
                    label={<LocalizedText textKey={TextKey.Sex} />}
                    name="gender"
                    showEmptyValue
                />
                {!isScanner && <TelephoneInputField />}
                <DateStringPickerField {...birthDateProps} allowDateReset={allowDateReset} />
            </FieldsContainer>
        );
    }
}

const firstNameProps = {
    label: <LocalizedText textKey={TextKey.FirstName} />,
    name: 'firstName',
};

const emailProps = {
    label: <LocalizedText textKey={TextKey.Email} />,
    name: 'email',
};

const languageProps = {
    label: <LocalizedText textKey={TextKey.PreferredLanguage} />,
    name: 'preferredLanguageCode',
};

const lastNameProps = {
    label: <LocalizedText textKey={TextKey.LastName} />,
    name: 'lastName',
    required: true,
};

const nationalityProps = {
    name: 'nationalityCode',
};

const birthDateProps = {
    name: 'birthDateString',
    label: <LocalizedText textKey={TextKey.BirthDate} />,
    showMonthSelector: true,
};

export const constraints = {
    firstName: {
        length: maxInputTextLength,
    },
    lastName: {
        presence,
        length: maxInputTextLength,
    },
    birthDateString: {
        dateString,
        birthDateRange,
    },
    email: {
        email,
    },
};
